<template>
  <div>
    <c-card title="상세" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-12 col-md-4 col-lg-4">
          <c-label-text title="재해발생원인(인적)" :value="accData.accidentCause"></c-label-text>
        </div>
        <div class="col-xs-12 col-md-4 col-lg-4">
          <c-label-text title="재해발생원인(물적)" :value="accData.accidentCauseM"></c-label-text>
        </div>
        <div class="col-xs-12 col-md-4 col-lg-4">
          <c-label-text title="재해발생원인(환경적)" :value="accData.accidentCauseE"></c-label-text>
        </div>
        <div class="col-xs-12 col-md-4 col-lg-4">
          <c-label-text title="재발방지대책(공학적)" :value="accData.engineeringRecurrence"></c-label-text>
        </div>
        <div class="col-xs-12 col-md-4 col-lg-4">
          <c-label-text title="재발방지대책(관리적)" :value="accData.managementRecurrence"></c-label-text>
        </div>
        <div class="col-xs-12 col-md-4 col-lg-4">
          <c-label-text title="환경안경팀 의견" :value="accData.managerOpinion"></c-label-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-upload 
            :editable="false">
          </c-upload>
        </div>
      </template>
    </c-card>
    <br>
    <c-table
      ref="tableImpr"
      title="수시 위험성평가"
      :columns="gridImpr.columns"
      :gridHeight="gridImpr.height"
      :data="accData.accidentImproveModelList"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="false"
      @table-data-change="tableDataChange"
    >
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="false"
            :isImmShow="true"
            :requestContentsCols="requestContentsCols"
            tableKey="causesNo"
            ibmTaskTypeCd="ITT0000040"
            ibmTaskUnderTypeCd="ITTU000065"
            @imprChange="imprChange"
          />
        </template>
      </template>
       <template slot="table-button">
        <q-chip icon="info" color="blue" size="16px" square outline clickable label="위험성 판단 기준" dense @click="riskCriteriaPopup = true" />
       </template>
    </c-table>
    <q-dialog v-model="riskCriteriaPopup">
      <q-card style="min-width:500px; max-width:70vw;">
        <q-card-section class="row items-center q-pb-none">
          <q-icon name="play_circle_outline" size="xs" class="q-mr-sm" /><b>위험성 판단 기준</b>
          <q-space />
          <q-btn icon="close" size="sm" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section>
          <table class="riskCriteriaTable">
            <thead>
              <tr>
                <th style="width:20%">위험성 수준</th>
                <th>판단 기준</th>
                <th style="width:15%">허용 가능 여부</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="riskLevelCell riskLevelHigh"><b class="text-red q-mr-sm">상(빨강)</b>: 매우높음</td>
                <td class="riskCriteriaCell">
                  · 사고 발생 시 사망 또는 장애가 남을 수 있는 위험<br />
                  · 산업안전보건법에 따른 기준을 만족시키지 못한 경우
                </td>
                <td rowspan="2">허용 불가능<br />(개선 후 작업)</td>
              </tr>
              <tr>
                <td class="riskLevelCell riskLevelMid"><b class="text-amber q-mr-sm">중(노랑)</b>: 보통</td>
                <td class="riskCriteriaCell">
                  · 사고 발생 시 3일 이상의 휴업이 필요한 경우<br />
                  · 아차사고 사례가 있는 경우
                </td>
              </tr>
              <tr>
                <td class="riskLevelCell riskLevelLow"><b class="text-green q-mr-sm">하(초록)</b>: 매우낮음</td>
                <td class="riskCriteriaCell">
                  · 3일 미만의 휴업 또는 작업 수행에 영향을 미치지 않는 경미한 부상 또는 질병이 예상되는 경우
                </td>
                <td>허용가능</td>
              </tr>
            </tbody>
          </table>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'cause-prevention-TL',
  props: {
    param: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
      }),
    },
  },
  data() {
    return {
      accData: {
        occurrenceDeptCd: '',
        accidentStatusCd: '',
        accidentCause: '',
        accidentCauseM: '',
        accidentCauseE: '',
        managerOpinion: '',
        engineeringRecurrence: '',
        managementRecurrence: '',
        accidentImproveModelList: [],
      },
      gridImpr: {
        columns: [
          {
            name: 'causeTypeCd',
            field: 'causeTypeCd',
            // 원인구분
            label: 'LBL00001560',
            align: 'center',
            style: 'width:15%',
            type: 'select',
            comboItems: [
              { code: 'ICDC000001', codeName: '기술적' },
              { code: 'ICDC000002', codeName: '교육적' },
              { code: 'ICDC000003', codeName: '관리적' },
            ],
            sortable: false,
          },
          {
            name: 'accidentCause',
            field: 'accidentCause',
            // 사고원인
            label: 'LBL00001561',
            align: 'left',
            style: 'width:50%',
            sortable: false,
          },
          {
            label: '개선전 위험성',
            align: 'center',
            child: [
              {
                name: 'brl00000001',
                field: 'brl00000001',
                label: '상',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'red', 
              },
              {
                name: 'brl00000005',
                field: 'brl00000005',
                label: '중',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'amber', 
              },
              {
                name: 'brl00000010',
                field: 'brl00000010',
                label: '하',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'green', 
              },
            ],
          },
          {
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'improvingMeasures',
                field: 'improvingMeasures',
                // 개선대책
                label: 'LBL00001563',
                align: 'left',
                style: 'width:20%',
                sortable: false
              },
              {
                name: 'customCol',
                field: 'customCol',
                // 개선번호/진행상태
                label: 'LBLIMPRNO_PROGRESS',
                align: 'center',
                style: 'width:15%',
                type: 'custom',
                sortable: false
              },
            ]
          },
          {
            label: '개선후 위험성',
            align: 'center',
            child: [
              {
                name: 'arl00000001',
                field: 'arl00000001',
                label: '상',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'red'
              },
              {
                name: 'arl00000005',
                field: 'arl00000005',
                label: '중',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'amber'
              },
              {
                name: 'arl00000010',
                field: 'arl00000010',
                label: '하',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'green'
              },
            ],
          },
        ],
        
        data: [],
        height: '315px'
      },
      editable: true,
      getUrl: '',
      riskCriteriaPopup: false,
    };
  },
  computed: {
    companyInfo() {
      return this.accData.accidentBirthDate + '/' + this.accData.accidentSpotName + '/' + this.accData.accidentAge + '/' + this.accData.accidentSexName + '/' + this.accData.accidentLongevityCount;
    },
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['accidentCause'];
    },
    // 개선요청 Component
    imprComponent() {
      let components = () => import(`${'@/pages/common/ibm/tableImpr.vue'}`);
      return components;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.getUrl = selectConfig.sop.iim.accident.process.prevention.get.url;
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      this.$http.url = this.$format(this.getUrl, this.param.iimAccidentId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.accData =  _result.data;
        this.$emit('accidentName', this.accData.processName)
      },);
    },
    // 개선창 닫기 후
    imprChange() {
      this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
    },
    tableDataChange(props, col) {
      if (!props.row[col.name]) return;
      if (col.name === 'causeTypeCd') {
        this.$set(props.row, 'causeTypeName', this.getCauseTypeName(props.row['causeTypeCd']));
      } else if (['brl00000001', 'brl00000005', 'brl00000010'].includes(col.name)) {
        if (props.row[col.name] === 'Y') {
          this.$_.forEach(['brl00000001', 'brl00000005', 'brl00000010'], name => {
            if (name !== col.name) this.$set(props.row, name, 'N');
          });
          this.$set(props.row, 'riskLevelB', this.$_.toUpper(col.name.substring(1)));
        } else this.$set(props.row, 'riskLevelB', '');
      } else if (['arl00000001', 'arl00000005', 'arl00000010'].includes(col.name)) {
        if (props.row[col.name] === 'Y') {
          this.$_.forEach(['arl00000001', 'arl00000005', 'arl00000010'], name => {
            if (name !== col.name) this.$set(props.row, name, 'N');
          });
          this.$set(props.row, 'riskLevelA', this.$_.toUpper(col.name.substring(1)));
        } else this.$set(props.row, 'riskLevelA', '');
      }
    },
  }
};
</script>

<style scoped>
.riskCriteriaTable th,
.riskCriteriaTable td {
  border: 1px solid #c9c8c8;
  padding: 8px 12px;
  font-size: 0.9em;
  text-align: center;
  vertical-align: middle;
}
.riskCriteriaTable thead th {
  background-color: #f5f5f5;
  font-weight: 700;
}
.riskCriteriaTable .riskCriteriaCell {
  text-align: left;
  line-height: 1.6;
}
</style>
